import React from "react";
import "../../../globalTypes";
import ErrorMessage from "./ErrorMessage";

type ErrorBoundaryProps = {
  children: React.ReactNode;
};
type ErrorBoundaryState = {
  error: Error | null;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    if (window.Sentry && process.env.SENTRY_ENABLE) {
      if (process.env.TEAM_TAG) {
        window.Sentry.setTag("team", process.env.TEAM_TAG);
      }
      window.Sentry.captureException(error, {
        data: errorInfo.componentStack,
      });
    }
  }

  render() {
    if (this.state.error) {
      return <ErrorMessage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
